import ServiceLayout, { ContentSection } from "@/components/site/ServiceLayout";
import { Reveal, TickList } from "@/components/site/Reveal";

const AREAS = [
  "Parent–child relationship difficulties",
  "Family conflict",
  "Separation and changing family structures",
  "Blended families",
  "Supporting a family member experiencing mental illness",
  "Trauma affecting the broader family",
  "Parenting communication",
  "Adult family relationships",
  "Carer stress",
  "Strengthening family boundaries",
];

const FORMATS = [
  {
    title: "Whole family sessions",
    text: "Everyone in the room together, working on the patterns that keep the family stuck.",
  },
  {
    title: "Individual family members",
    text: "One-to-one sessions that feed back into the broader family work.",
  },
  {
    title: "Different combinations",
    text: "Parents together, siblings together, or parent–child pairs — whatever the situation calls for.",
  },
];

export default function FamilyTherapy() {
  return (
    <ServiceLayout
      eyebrow="Services"
      title="Family Therapy"
      lead="Support for the family as a whole system — helping families understand each other, repair relationships and find steadier ground."
      image="/images/family-therapy.jpg"
      imageAlt="A parent and child making a heart shape with their hands"
    >
      <ContentSection eyebrow="Who this is for" title="Support for families navigating">
        <TickList items={AREAS} />
      </ContentSection>

      <ContentSection eyebrow="How sessions work" title="The whole family, parts of it, or one at a time" pale>
        <div className="grid gap-6 md:grid-cols-3">
          {FORMATS.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.08}>
              <div className="h-full rounded-2xl border border-euca-line bg-white p-7 shadow-sm">
                <span className="font-serif text-3xl italic text-euca-sage/70">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-4 font-serif text-xl font-medium text-euca-dark">{f.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-mutedsoft">{f.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <p className="mt-10 max-w-3xl text-base leading-relaxed text-mutedsoft">
            The format is decided with you at the start and can change as the work progresses. Funding depends on
            the participants and the referral — we will explain the options before you begin.
          </p>
        </Reveal>
      </ContentSection>
    </ServiceLayout>
  );
}
